// Testimony video grid - Splide on mobile only
document.addEventListener('DOMContentLoaded', function() {
  var grid = document.getElementById('temoignages_joueurs');
  if (!grid || !grid.querySelector('.splide__track')) return;

  var mql = window.matchMedia('(max-width: 639px)');
  var splideInstance = null;

  function handleMobile(e) {
    if (e.matches && !splideInstance) {
      splideInstance = new Splide(grid, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        autoplay: true,
        interval: 5000,
        pagination: true,
        arrows: true,
        gap: '1rem',
      });
      splideInstance.mount();
      grid.classList.add('is-slider');
    } else if (!e.matches && splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
      grid.classList.remove('is-slider');
    }
  }

  handleMobile(mql);
  mql.addEventListener('change', handleMobile);
});
